import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const UserExpert = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='UserExpert' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M14.6431888,15.6961461 C14.3091703,14.6675626 13.7524493,13.7598949 13.0233822,13.0234994 C11.7718684,11.7594056 10.0125018,11 8,11 C4,11 1,14 1,18 L1,23 L11,23 M12,18.8235294 L16.1904762,22 L23,13' />
  </StyledIcon>
);
